export const environment = {
  production: true,
  envName: 'Production',
  API_URL: 'https://api-vision.acttraining.org.uk/api/',
  statusPage: 'https://status.acttraining.org.uk/',
  tenantId: '6da945da-348b-4a3b-8ab2-f42a0e375185',
  clientId: '83363622-71e2-4e17-b1ae-58343ca5bdea',
  redirectUri: 'https://vision.acttraining.org.uk/redirect',
  logoutRedirectUri: `https://vision.acttraining.org.uk/log-out`,
  reportMaxPageSize: 999999,
  websiteURL: 'https://vision.acttraining.org.uk',
};
